import { API } from '../../apiClient.constants';

export const API_CAUSED_PAGE_ERROR: string[] = [
  API.getAuth,
  API.getUserPreference,
];

export const ERROR_TO_API_MAP = {
  [API.printWithMyData]: 'protoPog.table.print.errorMsg',
};
